<footer class="stitch-footer pt-5 pb-4">
  <div class="container-fluid px-lg-5">
    <div class="row g-4 mb-5 justify-content-between">
      
      <!-- Columna 1: Marca & Filosofía -->
      <div class="col-lg-4 col-md-6 pe-lg-5">
        <a routerLink="/" class="footer-brand-logo d-flex align-items-center text-decoration-none mb-3">
          <div class="footer-logo-icon">
            <i class="fas fa-mountain"></i>
          </div>
          <span class="footer-brand-title ms-2">Tienda Virtual</span>
        </a>
        <p class="footer-desc mb-4">
          Innovación, elegancia y calidad superior en cada detalle. Experiencia de compra premium con envíos seguros a toda Colombia.
        </p>
        <div class="footer-social-links d-flex align-items-center gap-3">
          <a href="#" class="social-icon-btn" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
          <a href="#" class="social-icon-btn" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
          <a href="#" class="social-icon-btn" aria-label="WhatsApp"><i class="fab fa-whatsapp"></i></a>
          <a href="#" class="social-icon-btn" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
        </div>
      </div>

      <!-- Columna 2: Navegación / Explorar -->
      <div class="col-lg-2 col-md-6 col-6">
        <h6 class="footer-heading mb-3">Navegación</h6>
        <ul class="footer-links-list list-unstyled m-0 p-0">
          <li><a routerLink="/" class="footer-link">Inicio</a></li>
          <li><a routerLink="/shop" class="footer-link">Catálogo de Productos</a></li>
          <li><a routerLink="/shop" [queryParams]="{ category: 'Ofertas Flash' }" class="footer-link">Ofertas Exclusivas</a></li>
          <li><a routerLink="/about" class="footer-link">Quiénes Somos</a></li>
        </ul>
      </div>

      <!-- Columna 3: Atención & Soporte -->
      <div class="col-lg-2 col-md-6 col-6">
        <h6 class="footer-heading mb-3">Soporte</h6>
        <ul class="footer-links-list list-unstyled m-0 p-0">
          <li><a routerLink="/profile" class="footer-link">Mi Cuenta & Pedidos</a></li>
          <li><a routerLink="/contact" class="footer-link">Centro de Ayuda</a></li>
          <li><a routerLink="/contact" class="footer-link">Radicación PQRS</a></li>
          <li><a routerLink="/contact" class="footer-link">Términos & Condiciones</a></li>
        </ul>
      </div>

      <!-- Columna 4: Suscripción Newsletter -->
      <div class="col-lg-3 col-md-6">
        <h6 class="footer-heading mb-3">Suscríbete</h6>
        <p class="footer-desc small mb-3">
          Recibe en tu correo lanzamientos exclusivos y beneficios VIP.
        </p>
        <div class="newsletter-input-group d-flex align-items-center">
          <input type="email" class="newsletter-input" placeholder="Tu correo electrónico..."
            [(ngModel)]="subscriberEmail" (keyup.enter)="subscribeNewsletter()" [disabled]="isSubmitting" />
          <button class="btn-newsletter-submit" aria-label="Suscribirse" (click)="subscribeNewsletter()" [disabled]="isSubmitting">
            <i class="fas" [ngClass]="isSubmitting ? 'fa-spinner fa-spin' : 'fa-arrow-right'"></i>
          </button>
        </div>
        <div *ngIf="subscribeMessage" class="mt-2 extra-small" [ngClass]="isSuccess ? 'text-success' : 'text-danger'">
          <i class="fas" [ngClass]="isSuccess ? 'fa-check-circle me-1' : 'fa-exclamation-circle me-1'"></i>
          {{ subscribeMessage }}
        </div>
      </div>

    </div>

    <hr class="footer-divider mb-4" />

    <!-- Copyright & Pasarelas de Pago Limpias -->
    <div class="row align-items-center footer-bottom-bar text-muted small">
      <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
        © 2026 Tienda Virtual Colombia. Todos los derechos reservados.
      </div>
      <div class="col-md-6 text-center text-md-end">
        <div class="minimal-pay-badges d-inline-flex align-items-center gap-3">
          <span class="pay-badge-item"><i class="fas fa-shield-alt text-primary me-1"></i> Pago 100% Seguro</span>
          <span class="pay-badge-item"><i class="fab fa-cc-visa"></i></span>
          <span class="pay-badge-item"><i class="fab fa-cc-mastercard"></i></span>
          <span class="pay-badge-item"><i class="fas fa-university me-1"></i> PSE</span>
        </div>
      </div>
    </div>

  </div>
</footer>
